function AccreditationPopup(settings = {}){
	this.className = "AccreditationPopup";

	this.name = "accreditation";

	// don't force to be 80% height, too big!
	//settings.autoHeight = true; // not working quite yet, might need to fiddle with this in a similar way as did with patently

	var submissionURLQueryString = '';
	//if(settings.role) submissionURLQueryString = "role=" + encodeURIComponent(settings.role);

	this.data = {
		pages: [{
			title: 	"Criterion",
			name: 	"criterion",
			submissionUrl: "/forms/?" + submissionURLQueryString,
			static:	true,
			onRender: ($wrapper) => {},
			init: () => {

				const $wrapper = this.$content;
				this.$wrapper = $wrapper;

				const r = this.values;
				this.evidenceRequired = r.evidence;
				this.isReadonly = r.isReadonly

				const $checkbox = $wrapper.find(".js-tick");
				const $finishButton = $wrapper.find(".js-finish");

				/*
				$wrapper.find('.checkbox-box-label').on("click", e => {
					console.log(r);
				});
				*/

				// Toggle checkbox
				$checkbox.on("change", e => {
					e.preventDefault();
					const isChecked = $checkbox.prop("checked");
					this.fire("update", { ticked: isChecked ? 1 : 0 });
				})

				// Close popup on button click
				$finishButton.on('click touchstart', (e) => {
					e.preventDefault();
					this.cancel();
				});

				// Load previously uploaded files into popup.
				if (this.evidenceRequired) {
					const uploadDetails = this.page.inputs.find(input => input.name === 'uploadfile');
					if(this.values.files) this.values.files.forEach(file => {
						this.addFile(uploadDetails, file, { save: false });
					});
					this.refreshFileList(uploadDetails);
				}
			}
		}]
	}

	this.setup(settings);
};
AccreditationPopup.inheritsFrom( PopupForm );

AccreditationPopup.prototype.refreshFileList = function(){

	const uploadDetails = this.page.inputs.find(input => input.name === 'uploadfile');
	const checkboxDetails = this.page.inputs.find(input => input.name === 'tick');

	// const required = this.values.evidenceRequired;// || true;
	const disabled = (this.evidenceRequired && !uploadDetails.files.length);

	const $tick = checkboxDetails.$input;
	if(disabled){
		const isTicked = $tick.prop("checked");
		if(isTicked) $tick.prop("checked",false).trigger("change");
	}

	$tick.prop("disabled", (disabled || this.isReadonly));

	// @todo - Slight bodge, might want to recheck.
	const $evidenceButtons = this.$wrapper.find('.upload-button, .upload-file-remove');
	if (this.isReadonly) {
		$evidenceButtons.hide();
	} else {
		$evidenceButtons.show();
	}

	return this.runParent("refreshFileList",arguments);
}
AccreditationPopup.prototype.submitFileList = function(d) {
	//if( ! d.files ) return false;

	const files = [];
	for(let index in d.files) {
		const file = d.files[index];
		files.push({
			'filename': file.filename,
			'originalFilename': file.originalFilename,
			'path': file.path,
		});
	}

	this.fire("update", { files: files });
}
AccreditationPopup.prototype.close = function(){
	this.fire("close");
	return this.runParent("close");
}